<template>
    <v-navigation-drawer
        v-model="drawer"
        app
    >
        <v-toolbar-title class="text-center pt-4 pb-2">
            <router-link :to="{name: 'orders'}">
                <img src="/img/logo.png" alt="" style="width:210px">
            </router-link>
        </v-toolbar-title>

        <div class="text-center">
            <v-btn
                :to="{name: 'order_create'}"
                class="my-5"
                rounded
                color="success"
            >{{ $t('layouts.components.main_menu.new_order') }}</v-btn>
        </div>

        <v-list dense shaped nav>
            <template v-for="(navSection, i) in availableNavSections">
                <div class="pa-1 mt-2 overline" v-if="navSection.name">{{navSection.name}}</div>
                <template v-for="(navSectionItem, j) in navSection.items">
                    <v-list-group
                        v-if="navSectionItem.items"
                        v-model="navSectionItem.active"
                        :key="'nav-list-group-i-'+i+'-j-'+j"
                    >
                        <template v-slot:activator>
                            <v-list-item-action>
                                <v-icon class="primary--text">{{navSectionItem.icon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{navSectionItem.title}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                            v-for="(item, k) in navSectionItem.items"
                            :to="{name: item.toName}"
                            exact
                            color="primary"
                            :key="'nav-list-item-i-'+i+'-j-'+j+'-k-'+k"
                        >
                            <v-list-item-action>
                                <v-icon class="primary--text">{{item.icon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{item.title}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item
                        v-else
                        :to="{name: navSectionItem.toName}"
                        exact
                        color="primary"
                        :key="'nav-list-group-i-'+i+'-j-'+j"
                    >
                        <v-list-item-action>
                            <v-icon class="primary--text">{{navSectionItem.icon}}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{navSectionItem.title}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </template>
        </v-list>

        <template v-slot:append>
            <div class="pa-2">
                <v-btn icon :title="$t('layouts.components.main_menu.web_service_integration')" :to="{name:'api'}">
                    <v-icon class="primary--text">mdi-api</v-icon>
                </v-btn>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import {Auth} from "../../modules/utils";

    export default {
        name: "MainMenu",

        props: {
            navToggle: Boolean,
        },

        data() {
            return {
                drawer: null,
                navSections: [
                    {
                        name: null,
                        forAdminOnly: false,
                        items: [
                            {
                                title: null, // see beforeMount() section
                                icon: "mdi-format-list-bulleted",
                                toName: 'orders'
                            },
                            {
                                title: null, // see beforeMount() section
                                icon: "mdi-clipboard-edit-outline",
                                toName: 'drafts'
                            },
                            {
                                title: null, // see beforeMount() section
                                icon: "mdi-bell-outline",
                                toName: 'complaints'
                            },
                        ]
                    },
                    {
                        name: "ADMINISTRACJA",
                        forAdminOnly: true,
                        items: [
                            {
                                title: "Wydania Zewnętrzne",
                                icon: "mdi-package-up",
                                toName: 'give_outs'
                            },
                            {
                                title: "Systemy",
                                icon: "mdi-layers-triple-outline",
                                toName: 'systems'
                            },
                            {
                                title: "Bryły",
                                icon: "mdi-desk",
                                toName: 'blocks'
                            },
                            {
                                title: "Kolory",
                                icon: "mdi-palette-outline",
                                toName: 'colors'
                            },
                            {
                                title: "Komplety",
                                icon: "mdi-package-variant-closed",
                                toName: 'packages'
                            },
                            {
                                title: "Komponenty",
                                icon: "mdi-puzzle-outline",
                                toName: 'units'
                            },
                            {
                                title: "Klienci",
                                icon: "mdi-account-multiple-outline",
                                toName: 'clients'
                            },
                            // {
                            //     title: "Użytkownicy",
                            //     icon: "mdi-account-multiple-outline",
                            //     toName: 'users'
                            // },
                            {
                                title: "Wiadomości",
                                icon: "mdi-bullhorn-outline",
                                toName: 'messages'
                            },
                            {
                                title: "Tagi",
                                icon: "mdi-tag-outline",
                                toName: 'tags'
                            },
                        ]
                    }
                ],
            };
        },

        computed: {
            availableNavSections: function () {
                return this.navSections.filter(navSection => {
                    return !navSection.forAdminOnly || Auth.isAdministrator();
                });
            },
            locale: function () {
                return this.$i18n.locale;
            },
        },

        beforeMount() {
            this.setMenuLabels();
        },

        methods: {
            resolveItemGroups() {
                this.availableNavSections.forEach(navSection => {
                    navSection.items.forEach(navSectionItem => {
                        if(navSectionItem.items) {
                            navSectionItem.active =
                                navSectionItem.items.map(item => item.toName).includes(this.$route.name);
                        }
                    });
                });
            },

            setMenuLabels() {
                this.navSections[0].items[0].title = this.$t('layouts.components.main_menu.orders');
                this.navSections[0].items[1].title = this.$t('layouts.components.main_menu.drafts');
                this.navSections[0].items[2].title = this.$t('layouts.components.main_menu.complaints');
            },
        },

        created() {
            this.resolveItemGroups();
        },

        watch: {
            '$route': function(value) {
                this.resolveItemGroups();
            },
            locale() {
                this.setMenuLabels();
            },
            navToggle(value) {
                this.drawer = !this.drawer;
            },
        },
    }
</script>

<style scoped>

</style>
